import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IPositionModel } from 'interfaces';
import { IArea, IAreaHead, IExecutor } from '../PageArea/interfaces';
import { IAreaContact } from './interfaces';

// Service org
export const getServiceOrgList = () => {
  return instance()
    .post('/dictionary/serviceOrgs', {})
    .then((response) => response.data);
};

export const updateServiceOrgName = (currentName: string, serviceOrgGuid: string) => {
  return instance()
    .post('/serviceOrg/update', { currentName, serviceOrgGuid })
    .then((response) => response.data);
};

// Service org heads
export const getServiceOrgHeads = (serviceOrgGuid: string) => {
  if (serviceOrgGuid) {
    return instance()
      .post<IExecutor[]>('/serviceOrgHead/list', { serviceOrgGuid })
      .then((response) => response.data);
  }
  return new Promise<IExecutor[]>((resolve) => resolve([]));
};

export const saveOrgHead = (positionId: number, serviceOrgGuid: string, userId: string) => {
  return instance()
    .post<IExecutor>('/serviceOrgHead/save', { positionId, serviceOrgGuid, userId })
    .then((response) => response.data);
};

export const deleteOrgHead = (positionId: number, serviceOrgGuid: string, userId: string) => {
  return instance()
    .post('/serviceOrgHead/delete', { positionId, serviceOrgGuid, userId })
    .then((response) => response.data);
};

// Areas
export const getAreaList = (serviceOrgGuid: string) => {
  if (serviceOrgGuid) {
    return instance()
      .post<IArea[]>('/area/list', { serviceOrgGuid })
      .then((response) => response.data);
  }
  return new Promise<IArea[]>((resolve) => resolve([]));
};

export const saveArea = (name: string, serviceOrgGuid: string) => {
  return instance()
    .post<IArea>('/area/save', { name, serviceOrgGuid })
    .then((response) => response.data);
};

export const updateAreaName = (areaId: number, name: string) => {
  return instance()
    .post<IArea>('/area/update', { areaId, name })
    .then((response) => response.data);
};

export const deleteAreaById = (areaId: number) => {
  return instance()
    .post('/area/delete', { areaId })
    .then((response) => response.data);
};

export const updateServiceOrg = (areaId: number, serviceOrg: string) => {
  return instance()
    .post('/area/updateServiceOrg', { areaId, serviceOrg })
    .then((response) => response.data);
};

// Area contacts
export const loadAreaContact = (areaId: number) => {
  return instance()
    .post<IAreaContact>('/area/loadContact', { areaId })
    .then((response) => response.data);
};

export const saveAreaContact = (data: IAreaContact) => {
  return instance()
    .post<IAreaContact>('/area/saveContact', data)
    .then((response) => response.data);
};

// Area heads
export const saveAreaHead = (areaId: number, positionId: number, userId: string) => {
  return instance()
    .post<IAreaHead>('/area/saveAreaHead', { areaId, positionId, userId })
    .then((response) => response.data);
};

export const deleteAreaHead = (areaId: number, positionId: number, userId: string) => {
  return instance()
    .post('/area/deleteAreaHead', { areaId, positionId, userId })
    .then((response) => response.data);
};

// Dictionaries
export const getPositions = () => {
  return instance()
    .post('/dictionary/adminPositions/listExecutors', {})
    .then((response) => response.data);
};

export const getPositionsByUserId = (userId: string) => {
  return instance()
    .post<IPositionModel[]>('/users/listPositionsByUserId', { userId })
    .then((response) => response.data);
};

// AsyncSearch-compatible; onlyActive — без отключённых и заблокированных: назначить их бэкенд всё равно не даст
export const getUsers = (config: AxiosRequestConfig = {}) => {
  const search = config.params?.search || null;
  const { params, ...rest } = config;
  return instance()
    .post('/users/list', search ? { search, onlyActive: true } : { onlyActive: true }, rest)
    .then((response) => response.data);
};

// Порядок должностей в составе сервисной компании (глобальный, на уровне должности)
export const getPositionsBySortOrder = () => {
  return instance()
    .post<IPositionModel[]>('/dictionary/adminPositions/bySortOrder')
    .then((response) => response.data);
};

export const reorderPositions = (orderedIds: number[]) => {
  return instance()
    .post('/dictionary/adminPositions/reorder', { orderedIds })
    .then((response) => response.data);
};
